(() => {
  var __webpack_exports__ = {};
  Shopify.theme.jsAjaxCart = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

      if (isScreenSizeLarge() || this.cart_action == 'drawer') {
        this.initializeAjaxCart();
      } else {
        this.initializeAjaxCartOnMobile();
      }

      if (this.cart_action == 'drawer') {

        this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

        $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
          e.preventDefault();
          Shopify.theme.jsAjaxCart.showDrawer();

          return false;
        });

      } else if (this.cart_action == 'mini_cart') {
        this.showMiniCartOnHover();
      }

      $(document).on('click', '.ajax-submit', function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest('form');
        Shopify.theme.jsAjaxCart.addToCart($addToCartForm);

        return false;
      });

      $(document).on('click', '[data-ajax-cart-delete]', function (e) {
        e.preventDefault();
        const lineID = $(this).parents('[data-line-item]').data('line-item');
        Shopify.theme.jsAjaxCart.removeFromCart(lineID);

        if (Shopify.theme.jsCart) {
          Shopify.theme.jsCart.removeFromCart(lineID);
        }

        return false;
      });

      $(document).on('click', '[data-ajax-cart-close]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.hideDrawer();
        Shopify.theme.jsAjaxCart.hideMiniCart();

        return false;
      });

    },
    showMiniCartOnHover: function () {
      const $el = $('[data-ajax-cart-trigger]');

      $el.hover(function () {
        if (Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
          $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
        } else {
          $el.addClass('show-mini-cart');
        }
      }, function () {
        $el.removeClass('show-mini-cart');
      });
    },
    hideMiniCart: function () {
      if (this.cart_action != 'mini_cart') return false;
      const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
      $el.removeClass('show-mini-cart');
    },
    toggleMiniCart: function () {
      const $el = $('.mobile-header [data-ajax-cart-trigger]');

      // Removes url to the cart page so user is not redirected
      $el.attr('href', '#');

      $el.off('touchstart').on('touchstart', function (e) {
        // If user clicks inside the element, do nothing
        if (e.target.closest('[data-ajax-cart-mini_cart]')) {
          return;
        }

        // Loads content into ajaxCart container for mobile header
        Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile();

        // If user clicks outside the element, toggle the mini cart
        $el.toggleClass('show-mini-cart');
      });
    },
    showDrawer: function () {
      if (this.cart_action != 'drawer') return false;
      this.ajaxCartDrawer.addClass('is-visible');
      $('.ajax-cart__overlay').addClass('is-visible');
    },
    hideDrawer: function () {
      if (this.cart_action != 'drawer') return false;
      this.ajaxCartDrawer.removeClass('is-visible');
      $('.ajax-cart__overlay').removeClass('is-visible');
    },
    removeFromCart: function (lineID, callback) {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&line=' + lineID,
        dataType: 'json',
        success: function (cart) {
          Shopify.theme.jsAjaxCart.updateView();
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;

        }
      });
    },
    initializeAjaxCart: function () {

      Shopify.theme.asyncView.load(
        Shopify.routes.cart_url, // template name
        'ajax', // view name (suffix)
      )
        .done(({ html, options }) => {

          $('[data-ajax-cart-content]').html(html.content);

          // Converting the currencies
          if (Shopify.theme.currencyConverter) {
            Shopify.theme.currencyConverter.convertCurrencies();
          }

        })
        .fail(() => {
          // some error handling
        });
    },
    initializeAjaxCartOnMobile: function () {

      this.toggleMiniCart();

      Shopify.theme.asyncView.load(
        Shopify.routes.cart_url, // template name
        'ajax', // view name (suffix)
      )
        .done(({ html, options }) => {

          $('.mobile-header [data-ajax-cart-content]').html(html.content);

        })
        .fail(() => {
          // some error handling
        });
    },
    addToCart: function ($addToCartForm) {
      const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

      $addToCartForm.removeClass('shopify-product-form--unselected-error');

      if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${Shopify.translation.select_variant}</p>`;

        $('.warning').remove();

        $addToCartForm
          .addClass('shopify-product-form--unselected-error')
          .find('.cart-warning')
          .html(cartWarning);

        $addToCartBtn
          .removeAttr('disabled')
          .removeClass('disabled');

        $addToCartBtn.find('.icon')
          .removeClass('zoomOut')
          .addClass('zoomIn');

        $addToCartBtn
          .find('span:not(.icon)')
          .text($addToCartBtn.data('label'))
          .removeClass('zoomOut')
          .addClass('zoomIn');
      } else {
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: $addToCartForm.serialize(),
          beforeSend: function () {
            $addToCartBtn
              .attr('disabled', 'disabled')
              .addClass('disabled');

            $addToCartBtn.find('span')
              .removeClass("fadeInDown")
              .addClass('animated zoomOut');
          },
          success: function (product) {

            let $el = $('[data-ajax-cart-trigger]');

            $addToCartBtn
              .find('.checkmark')
              .addClass('checkmark-active');

            function addedToCart() {

              if (!isScreenSizeLarge()) {
                $el = $('.mobile-header [data-ajax-cart-trigger]');
                Shopify.theme.scrollToTop($el);
              } else {
                $el = $('[data-ajax-cart-trigger]');
              }

              $el.addClass('show-mini-cart');

              $addToCartBtn.find('span')
                .removeClass('fadeInDown');
            }

            // window.setTimeout(function () {
              $addToCartBtn
                .removeAttr('disabled')
                .removeClass('disabled');

              $addToCartBtn.find('.checkmark')
                .removeClass('checkmark-active');

              $addToCartBtn.find('.text, .icon')
                .removeClass('zoomOut')
                .addClass('fadeInDown');

              // $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

              // addedToCart();
            // }, 1000);

            Shopify.theme.jsAjaxCart.showDrawer();
            Shopify.theme.jsAjaxCart.updateView(addedToCart);

            if (Shopify.theme.jsCart) {
              $.ajax({
                dataType: "json",
                async: false,
                cache: false,
                dataType: 'html',
                url: "/cart",
                success: function (html) {
                  const cartForm = $(html).find('.cart__form');
                  $('.cart__form').replaceWith(cartForm);

                }
              });
            }

          },
          error: function (XMLHttpRequest) {
            let response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;

            const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

            $('.warning').remove();

            $addToCartForm
              .find('.cart-warning')
              .html(cartWarning);

            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.icon')
              .removeClass('zoomOut')
              .addClass('zoomIn');

            $addToCartBtn
              .find('span:not(.icon)')
              .text($addToCartBtn.data('label'))
              .removeClass('zoomOut')
              .addClass('zoomIn');
          }
        });
      }
    },
    updateView: function (callback) {

      Shopify.theme.asyncView.load(
        Shopify.routes.cart_url, // template name
        'ajax', // view name (suffix)
      )
        .done(({ html, options }) => {

          if (options.item_count > 0) {
            const itemList = $(html.content).find('.ajax-cart__list');
            const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');

            $('.ajax-cart__list').replaceWith(itemList);
            $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
            $('.ajax-cart__empty-cart-message').addClass('is-hidden');
            $('.ajax-cart__form').removeClass('is-hidden');
            $('[data-ajax-cart-trigger]').addClass('has-cart-count');
            $('[data-bind="itemCount"]').text(options.item_count);

          } else {
            $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
            $('.ajax-cart__form').addClass('is-hidden');
            $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
            $('[data-bind="itemCount"]').text('0');
          }

          if (Shopify.theme.currencyConverter) {
            Shopify.theme.currencyConverter.convertCurrencies();
          }

          if (callback) {
            callback();
          }
        })
        .fail(() => {
          // some error handling
        });
    },
    unload: function ($section) {

      // Clear event listeners in theme editor
      $('.ajax-submit').off();
      $('[data-ajax-cart-delete]').off();
    }
  }
})();


(() => {
  var __webpack_exports__ = {};
  Shopify.theme.jsHeader = {
    init: function ($section) {

      if (Shopify.theme_settings.search_layout !== 'overlay' && typeof $.fancybox === 'undefined') {
        Promise.all([
          window.loadLibScript(window.fancybox_lib_url),
          window.loadLibCSS(window.fancybox_css_url)
        ]).then(function () {
          console.log('Fancybox library and CSS loaded successfully.');
          // Initialize Fancybox if needed
          // $('[data-fancybox]').fancybox();
        }).catch(function (error) {
          console.error('Error loading Fancybox library or CSS:', error);
        });
      }

      // Add settings from schema to current object
      Shopify.theme.jsHeader = $.extend(this, Shopify.theme.getSectionData($section));

      // Selectors
      this.$el = $('#header')
      this.$menuToggle = this.$el.find('.header__menu-toggle');
      let announcementHeight = $('.announcement-sticky-wrapper').height();

      // Overlaid header
      if (this.enable_overlay === true && isScreenSizeLarge()) {
        this.updateOverlayStyle(this.sectionUnderlayIsImage());
      }

      // Sticky header
      if (this.enable_sticky === true && isScreenSizeLarge()) {
        // this.enableSticky(announcementHeight);

        $(window).on('resize', () => {
          // this.enableSticky(announcementHeight);
        });
      }

      if (this.header_layout == 'centered' || this.header_layout == 'search_focus') {
        this.$menuToggle.on('click', () => {
          this.showStickyMenu();
        })
      } else if (this.header_layout == 'vertical') {
        $section.find('.header-sticky-wrapper').stick_in_parent();
        if (Shopify.theme_settings.announcement_enabled == true) {
          Shopify.theme.jsAnnouncementBar.addVerticalHeaderTopMargin();
        }
        this.addOffScreenDropdownCheck();
      }

      if ($('.mega-menu').length > 0) {
        Shopify.theme.jsMegaMenu.init($section);
      }

      if (!isScreenSizeLarge()) {
        this.unload();
        Shopify.theme.mobileMenu.init();
      }

      $('.search-overlay__close').on('click', function () {
        Shopify.theme.jsHeader.hideSearch();
      });

      $(document).on('click', '[data-show-search-trigger]', function () {
        Shopify.theme.jsHeader.showSearch();
      });

      if (isScreenSizeLarge() || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        $('.dropdown-click--true .header__link:not(.primary-brand, .primary-logo)').on('click touchstart', function (e) {
          var $this = $(this);
          Shopify.theme.jsHeader.toggleMenuClick(e, $this);
        });
      }

      if (this.dropdown_click === false) {
        $('.navbar-item').on('mouseleave', function () {
          Shopify.theme.jsHeader.collapseSubmenu($(this));
        });
      }

      $(document).on('keydown', '[data-show-search-trigger]', function (e) {
        if (e.which === 13) {
          Shopify.theme.jsHeader.showSearch();
        }
      });

    },
    toggleMenuClick: function (e, $this) {
      var $parentWrap = $this.parents('.has-dropdown, .has-mega-menu');

      if (!$parentWrap.hasClass('is-opened') && $parentWrap.length > 0) {
        // Prevent link on first click
        e.preventDefault();

        // Close all dropdowns & mega menu
        $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
        $('.mega-menu__section').removeClass('is-active');

        // Open selected dropdown/mega menu
        $parentWrap.addClass('is-opened');
        $parentWrap.data('clicked', 'true');
      } else {

        // Close all dropdowns & mega menu
        $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
        $('.mega-menu__section').removeClass('is-active');
      }

      // Close dropdown if click anywhere outside dropdown menu
      $(window).on('click', function (e) {
        if ($(e.target).closest('.header__link, .navbar-dropdown').length === 0) {
          $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
          $('.mega-menu__section').removeClass('is-active');
          Shopify.theme.jsHeader.collapseSubmenu($('.navbar-item'));
        }
      });
    },
    collapseSubmenu: function (el) {
      $(el).find('.has-submenu input').prop("checked", false);
    },
    showStickyMenu: function () {
      this.$menuToggle.toggleClass('is-active');
      this.$el.find('.sticky-menu-wrapper').toggleClass('is-visible');
    },
    hideStickyMenu: function () {
      this.$menuToggle.removeClass('is-active');
      this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
    },
    disableSticky: function () {
      let $stickyEl = $('#header');

      $stickyEl.unstick();
      $stickyEl.removeClass('sticky--enabled');

      setTimeout(function () {
        $stickyEl.css('height', 'auto');
      }, 250)
    },
    enableSticky: function (offset) {
      let $stickyEl = this.$el;

      $stickyEl.addClass('sticky--enabled');

      $stickyEl.sticky({
        wrapperClassName: 'header-sticky-wrapper',
        zIndex: 40,
        topSpacing: offset || 0
      })
        .on('sticky-start', () => {
          let headerHeight;
          let announcementHeight;

          // Hide the mini cart for centered header layout
          if (Shopify.theme_settings.header_layout == 'centered') {
            $('[data-ajax-cart-trigger]').removeClass('show-mini-cart');
          }

          // Get header height is sticky enabled
          if (Shopify.theme.jsHeader.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
            headerHeight = Shopify.theme.jsHeader.getHeaderHeight();
          }

          // Get announcement height is sticky enabled
          if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
            announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
          } else {
            announcementHeight = 0;
          }

          let totalHeight = headerHeight + announcementHeight;
          $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');

          if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {

            $stickyEl.parent().addClass('has-overlaid-header');
            this.disableOverlayStyle();

          } else if (this.enable_overlay === true) {

            this.disableOverlayStyle();

          }
        })
        .on('sticky-end', () => {
          $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%');

          // Safety timeout for logo width transition which can throw calculated height off
          setTimeout(() => {
            $stickyEl.sticky('update');
          }, 250);

          this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
          this.$menuToggle.removeClass('is-active');

          if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {
            this.updateOverlayStyle(this.sectionUnderlayIsImage());
          }
        })
    },
    disableOverlayStyle: function () {
      $('[data-enable_overlay]').attr('data-enable_overlay', false);
    },
    enableOverlayStyle: function () {
      $('[data-enable_overlay]').attr('data-enable_overlay', true);
    },
    updateOverlayStyle: function (overlayBoolean) {
      $('[data-enable_overlay]').attr('data-enable_overlay', overlayBoolean);
    },
    sectionUnderlayIsImage: function () {

      let $firstSection = $('[data-check-for-order=true]').find('[id^=shopify-section]').first();

      // Check whether the first element has class to indicate it should be under header when overlay is enabled
      if ($firstSection.hasClass('overlaid-header-option') && $.trim($firstSection.html()).length > 0) {
        return true;
      } else {
        return false;
      }

    },
    showSearch: function () {
      $('[data-show-search-trigger]').addClass('is-active');
      if (Shopify.theme_settings.search_layout == 'overlay') {
        $('[data-search-type="' + Shopify.theme_settings.search_layout + '"]').toggleClass('is-opened');
        $('.search-form .search__fields input[type="text"]').focus();
      } else {
        $.fancybox.open($('.js-search-popup'), {
          baseClass: 'search__lightbox',
          hash: false,
          infobar: false,
          toolbar: false,
          loop: true,
          smallBtn: true,
          mobile: {
            preventCaptionOverlap: false,
            toolbar: false,
          },
          beforeClose: function () {
            $('[data-show-search-trigger]').removeClass('is-active');
          }
        })
      }
    },
    hideSearch: function () {
      $('[data-show-search-trigger]').removeClass('is-active');
      if (Shopify.theme_settings.search_layout == 'overlay') {
        $('[data-search-type="' + Shopify.theme_settings.search_layout + '"]').removeClass('is-opened');
      } else {
        $.fancybox.close($('[data-search-type="' + Shopify.theme_settings.search_layout + '"]'));
      }
    },
    addOffScreenDropdownCheck: function () {
      $('.navbar-item.has-dropdown--vertical').hover(function () {

        const dropdown = $(this),
          menu = dropdown.find('.navbar-dropdown');

        menu.removeClass('navbar-dropdown--fix-offscreen');

        if (menu.is(':off-screen')) {
          menu.addClass('navbar-dropdown--fix-offscreen');
        }

      });
    },
    getHeaderHeight: function () {
      const headerHeight = $('.header-section').outerHeight() || 0;

      return headerHeight;
    },
    unload: function ($section) {
      $('.has-overlaid-header').removeClass('has-overlaid-header');
      $('[data-show-search-trigger]').off();
      $('.navbar-item').off();
      $('#header').off();
      $('.dropdown-click--true .header__link').off();
      this.$menuToggle.off();
      // this.disableSticky();
      this.disableOverlayStyle();
    }
  }
})();


(() => {
  var __webpack_exports__ = {};
  Shopify.theme.jsMegaMenu = {
    init: function ($section) {
      // Add settings from schema to current object
      Shopify.theme.jsMegaMenu = $.extend(this, Shopify.theme.getSectionData($section));

      if (window.matchMedia('(min-width: 1024px)').matches) {
        var parentLink = this.parent_link;
        var sectionId = this.section_id;
      }

      // Selectors
      //const parentLink = this.parent_link; RQ! hide new
      //const sectionId = this.section_id; RQ! hide new
      const $megaMenu = $section.find('.mega-menu__' + sectionId);
      const $parentElement = $('.header__menu [data-navlink-handle="' + parentLink + '"], .sticky-header__menu [data-navlink-handle="' + parentLink + '"]');
      const $parentElementLink = $parentElement.children('.header__link');
      // Remove old mega menus
      $parentElement.find('.mega-menu__section').remove();

      // Mobile Selectors
      const $parentMobileElement = $(`[data-mobile-menu-navlink-handle="${parentLink}"]`);

      /* No submenu is present - add mega menu elements and caret */
      if ($parentMobileElement.find('.has-no-submenu').length) {

        // Assign class to display dropdown arrow
        $parentMobileElement.find('a.mobile-menu__item').addClass('mobile-menu-link');

        // Insert close icon after menu item
        $parentMobileElement.find('a').after('<span class="close-dropdown" aria-expanded="false"></span>');

        // Insert placeholder ul for megamenu
        $parentMobileElement.find('.submenu__label').after('<ul class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list></ul>')

        // Find data attribute for toggle and assign it true
        let $mobileMenuToggle = $parentMobileElement.find('[data-mobile-menu-has-toggle]');
        $($mobileMenuToggle).attr('data-mobile-menu-has-toggle', true);


        // Insert mega menu
        let $parentList = $parentMobileElement.find('.has-mega-menu');
        $megaMenu.clone().appendTo($parentList);

      } else {
        /* Submenu is present - add mega menu elements and remove current sub-menu */
        let $parentList = $parentMobileElement.find('[data-mobile-submenu-first-level-list]');

        $parentList
          .empty()
          .addClass('has-mega-menu')
          .removeClass('has-dropdown');

        // Insert mega menu
        $megaMenu.clone().appendTo($parentList);
      }


      // Desktop
      if ($parentElement.hasClass('header__item') || $parentElement.hasClass('vertical-header__first-level')) {
        // Hide default dropdown
        $parentElement.find('.navbar-dropdown').addClass('is-invisible is-hidden');

        // Add arrow to parent link to indicate dropdown
        $parentElementLink.removeClass('is-arrowless');

        $megaMenu.clone().appendTo('.vertical-header__first-level[data-navlink-handle="' + parentLink + '"], .header__item[data-navlink-handle="' + parentLink + '"]');

        // Add/remove classes for proper styling and append mega menu instance
        $parentElement.addClass('has-mega-menu')
      }

      // Determine if header is set to hover to open or click to open
      if ($('.dropdown-click--false').length > 0) {
        $('.navbar-item, .header__brand, .header__search').on('mouseover', function () {

          //Close any mega menus on hover
          $('.mega-menu__section').removeClass('is-active');

          if ($(this).hasClass('has-mega-menu')) {

            //Toggle corresponding mega menu
            $(this).find('.mega-menu__section').addClass('is-active');
          }
        })

        $('.mega-menu__section, .navbar').on('mouseleave', function () {

          //Hide mega menu upon leaving mega menu, logo or navbar
          $('.mega-menu__section').removeClass('is-active');
        })
      } else {
        $('.navbar-item, .header__brand, .header__search').on('click touchstart', function () {

          //Close any mega menus on click
          $('.mega-menu__section').removeClass('is-active');

          if ($(this).hasClass('has-mega-menu')) {

            //Toggle corresponding mega menu
            $(this).find('.mega-menu__section').addClass('is-active');
          }
        })
      }
    },
    showThemeEditorState: function (id, $section) {
      $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--force-show');
      $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').addClass('is-active');
    },
    hideThemeEditorState: function (id, $section) {
      $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--force-show');
      $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').removeClass('is-active');
    },
    displayMenu: function (id) {
      $('.mega-menu').removeClass('mega-menu--show');
      $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--show');
    },
    hideMenu: function (id) {
      $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--show');
    },
    unload: function ($section) {
      let parentLink = $section.find('.mega-menu').data('parent-link');
      let navLink = $('[data-navlink-handle="' + parentLink + '"]')
      navLink.off();
      navLink.find('.mega-menu__section').remove();
      $('.mega-menu__section, .navbar, .navbar-item, .header__brand, .header__search').off();
    }
  }
})();


(() => {
  var __webpack_exports__ = {};
  Shopify.theme.jsFeaturedCollection = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

      // if(this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      //   Shopify.theme.applyMasonry();
      // }

      if (this.collection_style == 'slider') {
        this.createSlider();
      }


    },
    createSlider: function () {

      let featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery');

      const slideData = {
        products_per_slide: this.products_per,
        products_available: this.products_available,
        products_limit: this.products_limit,
        wrapAround: true
      }

      $(featuredCollectionSlider).flickity({
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        pageDots: false,
        contain: true,
        prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
        initialIndex: 1,
        arrowShape: {
          x0: 10,
          x1: 60, y1: 50,
          x2: 70, y2: 40,
          x3: 30
        },
        on: {
          ready: function () {
            // Resize flickity when the slider is settled
            $(featuredCollectionSlider).on('settle.flickity', function () {
              $(featuredCollectionSlider).flickity('resize')
            });
          }
        }
      });

    },
    unload: function ($section) {
      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }
})();


/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsSidebar = {
    init: function() {
  
      const facetedFilterForm = document.querySelector('[data-faceted-filter-form]')
      if (facetedFilterForm) {
        facetedFilterForm.addEventListener('change', e => {
          if (e.target.type == 'number') return;
          facetedFilterForm.submit();
        });
      }
  
      const openSidebarBlocks = document.querySelectorAll('[data-sidebar-block__toggle="open"]');
  
      openSidebarBlocks.forEach(function(block){
        Shopify.theme.jsSidebar.openSidebarBlock($(block));
      })
  
  
      $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="closed"]', function (e) {
  
        e.preventDefault();
        Shopify.theme.jsSidebar.openSidebarBlock($(this));
      });
  
      $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="open"]', function(e) {
  
        e.preventDefault();
        Shopify.theme.jsSidebar.closeSidebarBlock($(this));
      });
  
      if ($('[data-product-sidebar]').length) {
        $('.section--has-sidebar-option').addClass('has-sidebar-enabled');
        $('.section--has-sidebar-option').removeClass('has-sidebar-disabled');
      } else {
        $('.section--has-sidebar-option').removeClass('has-sidebar-enabled');
        $('.section--has-sidebar-option').addClass('has-sidebar-disabled');
  
      }
  
    },
    openSidebarBlock: function ($toggleBtn) {
  
      const $parentBlock = $toggleBtn.closest('.sidebar__block');
      const $toggleIcon = $toggleBtn.find('.icon');
  
      $toggleBtn.attr('data-sidebar-block__toggle', 'open');
  
      $parentBlock.addClass('is-active');
      $parentBlock.attr('aria-expanded', true);
      $parentBlock.find('[data-sidebar-block__content--collapsible]').slideDown();
    },
    closeSidebarBlock: function ($toggleBtn) {
  
      const $parentBlock = $toggleBtn.closest('.sidebar__block');
      const $toggleIcon = $toggleBtn.find('.icon');
  
      $toggleBtn.attr('data-sidebar-block__toggle', 'closed');
  
      $parentBlock.removeClass('is-active');
      $parentBlock.attr('aria-expanded', false);
      $parentBlock.find('[data-sidebar-block__content--collapsible]').slideUp();
    },
    unload: function() {
      const $toggleBtn = $('[data-sidebar-block__toggle]');
      $toggleBtn.off();
    }
  }
  
  /******/ })()
  ;


  /******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsBlog = {
  init: function($section){

    // Add settings from schema to current object
    Shopify.theme.jsBlog = $.extend(this, Shopify.theme.getSectionData($section));

    if(this.enable_filter == true) {
      $('#blog_filter').on('change', function() {
        Shopify.theme.jsBlog.blogFilter();
      });
    }

  },
  blogFilter: function() {
    let url = $('#blog_filter').val();
    window.location = url;
  },
  unload: function($section) {
    $('#blog_filter').off();
  }
}
/******/ })()
;

/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsSearch = {
    init: function($section) {
  
      // Add settings from schema to current object
      Shopify.theme.jsSearch = $.extend(this, Shopify.theme.getSectionData($section));
  
      // If breadcrumbs enabled and basic pagination is set, call breadcrumbs object
      if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
        Shopify.theme.breadcrumbs.init(this.number_of_pages);
      }
    },
    unload: function($target) {
      Shopify.theme.breadcrumbs.unload();
    }
  }
  
  
  /******/ })()
  ;



  /******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCollection = {
  init: function($section) {

    // Add settings from schema to current object
    Shopify.theme.jsCollection = $.extend(this, Shopify.theme.getSectionData($section));

    // function to check if browser is IE
    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

    // Ensure product media libraries are present
    if (!isIE11) {
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
        }
      ],)
    }

    if (this.enable_sorting == true) {
      $('#sort-by').val($('#sort-by').data('default-sort'));
    }

    if (this.enable_filter == true || this.enable_sorting == true) {
      $('#tag_filter, #sort-by').on('change', function() {
        Shopify.theme.jsCollection.filterURL();
      });
    }

    if ($('[data-option-filter]').length) {
      // Show enabled filter tags based on selected checkboxes
      $('[data-tag-filter-checkbox]:checked').each(function(){
        Shopify.theme.jsCollection.multiTagFilter.showSelectedFilter($(this));
      })
    }

    // If breadcrumbs enabled and basic pagination is set, call breadcrumbs object
    if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
      Shopify.theme.breadcrumbs.init(this.number_of_pages);
    }

    /* Collection sidebar filter */
    $('body').on('click', '[data-option-filter]', function(e) {
      e.preventDefault();

      $(this).find('input').prop('checked', true);

      Shopify.theme.jsCollection.multiTagFilter.init($(this));
      Shopify.theme.scrollToTop($('.collection__content'));
    });

    $('body').on('click', '[data-clear-filter]', function () {
      const $el = $(this).siblings('[data-option-filter]');
      const $productTagFilter = $('#tag_filter');

      $productTagFilter.find('option:eq(0)').prop('selected', true);
      Shopify.theme.jsCollection.multiTagFilter.clearSelectedFilter($el);
      Shopify.theme.scrollToTop($('.collection__content'));

    });
  },
  filterURL: function() {

    var selectedOptions = [],
        query = '',
        currentTags = '',
        siteUrl = 'https://' + $.url('hostname');

    // check if language has been translated. Length equals one when default language (eg: '/') and greater than 1 when language is translated (eg: '/fr')
    if (Shopify.routes.root_url.length > 1) {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var url3 = $.url('3') ? $.url('3') + '/' : '';
      var path = url1 + url2 + url3;
    } else {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var path = url1 + url2;
    }

    //Handle dropdowns if they exist
    if ($('#sort-by').length){
      query = $('#sort-by').val();
    } else {
      query = url('?sort_by');
    }

    if ($('#tag_filter').length){

      if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()){
        var urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

        if (urlTag != 'all'){
          if ($.inArray( urlTag, selectedOptions ) > -1){
            //Do nothing
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    }

    //Add all checkbox values to array
    $('[data-option-filter] input:checked').each(function () {
      selectedOptions.push($(this).val());
    });

    selectedOptions = $.makeArray(selectedOptions);

    //Loop through tags to create string to update page url
    $.each(selectedOptions, function(i, value){

      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }

    });

    Shopify.theme.queryParameters.sort_by = query;
    query = '?' + $.param(Shopify.theme.queryParameters);

    this.processUrl(path, currentTags, query);
  },
  processUrl: function (path, tags, query) {

    var query = query.replace(/\page=(\w+)&/, ''),
      urlString = '';

    urlString = path + tags + query;

    this.updateView(urlString);

  },
  updateView: function(filterURL) {
    $.ajax({
      type: 'GET',
      url: filterURL,
      beforeSend: function() {
        $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
        $('.collection-matrix__wrapper .collection__loading-icon').fadeIn();
      },
      success: function(data) {
      },
      error: function(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);

      },
      dataType: "html"
    }).then(function(data){

      const $breadcrumbContainer = $('.breadcrumb__container');
      const $collectionMatrix = $('.collection-matrix');
      const $collectionMain = $('[data-collection-main]');

      // Get and set new breadcrumb html
      const filteredBreadcrumb = $(data).find('.breadcrumb__container').html();
      $breadcrumbContainer.html(filteredBreadcrumb);

      // Remove loading animation
      $collectionMatrix.removeClass('fadeIn animated loading-in-progress');

      // Check for products
      const filteredData = $(data).find('.collection-matrix__wrapper');
      const filteredPageLinks = $(data).find('.container--pagination');
      const noProducts = $(data).find('.container--no-products-in-collection');

      if (filteredData.length) {
        // Add products to container
        $collectionMain.empty();
        $collectionMain.append(filteredData);
      } else {
        // Display no product message
        $collectionMain.empty();
        $collectionMain.append(noProducts);
      }

      $collectionMain.append(filteredPageLinks);

      window.history && window.history.pushState && window.history.pushState("", "", filterURL);

      if(Shopify.theme_settings.enable_shopify_collection_badges == true) {
        Shopify.theme.productReviews();
      }

      // Initiate infinite scrolling on new products appended to collection grid
      if ($('[data-custom-pagination]').length) {
        Shopify.theme.infiniteScroll.init();
      }

    });
  },
  multiTagFilter: {
    init: function ($el) {

      // Show filter and hide siblings
      this.showSelectedFilter($el);

      // Update url
      Shopify.theme.jsCollection.filterURL();

      var urlIndex;
      if (Shopify.routes.root_url.length > 1) {
        urlIndex = 3
      } else {
        urlIndex = 2
      }

      // Hide filters if types or vendors is in URL (can't be combined)
      if ($.url(urlIndex) === 'types' || $.url(urlIndex) === 'vendors') {
        $('.block__tag-filter').remove();
      }

    },
    showSelectedFilter: function ($el) {
      const $sidebarToggleBlock = $el.parents('.sidebar-toggle-active');
      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.addClass('is-active');
      $filterItem.siblings(':not(.is-active)').addClass('is-hidden');
      $filterItem.find('[data-clear-filter]').removeClass('is-hidden');

      // If sidebar toggle is enabled, show filter in sidebar content
      if ($sidebarToggleBlock.length) {
        let $toggleBtn = $sidebarToggleBlock.find('[data-sidebar-block__toggle="closed"]');

        Shopify.theme.jsSidebar.openSidebarBlock($toggleBtn);
      }

    },
    clearSelectedFilter: function ($el) {

      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.removeClass('is-active')
            .find('input').prop("checked", false);
      $filterItem.siblings()
            .removeClass('is-hidden');
      $filterItem.find('[data-clear-filter]')
            .addClass('is-hidden');

      //Update url
      Shopify.theme.jsCollection.filterURL();
    }
  },
  unload: function($section) {
    $('#tag_filter, #sort-by').off();
    $('[data-option-filter]').off();
    $('[data-reset-filters]').off();
    $('[data-clear-filter]').off();
    Shopify.theme.breadcrumbs.unload();
  }
}

/******/ })()
;


class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider_container = this.querySelector(".grid-slider");
    this.slider_item = this.querySelector(".slider__item");
    this.slider_item_width = this.slider_item.offsetWidth;

    // Add click handlers
    this.querySelectorAll(".slider__arrow--back").forEach((arrow) => {
      arrow.addEventListener("click", () => this.navigate("backward"));
    });
    this.querySelectorAll(".slider__arrow--forward").forEach((arrow) => {
      arrow.addEventListener("click", () => this.navigate("forward"));
    });

    // this.querySelectorAll(".slide-indicator")
    //     .forEach((dot, index) => {
    //         dot.addEventListener("click", () => navigate(index));
    //         dot.addEventListener("mouseenter", () => clearInterval(autoplay));
    //     });

    // Add keyboard handlers
    this.addEventListener("keydown", (e) => {
      if (e.code === "ArrowLeft") {
        // clearInterval(autoplay);
        this.navigate("backward");
      } else if (e.code === "ArrowRight") {
        // clearInterval(autoplay);
        this.navigate("forward");
      }
    });

    // Add resize handler
    window.addEventListener("resize", () => {
      this.slider_item_width = this.slider_item.offsetWidth;
    });

    // Autoplay
    // const autoplay = setInterval(() => navigate("forward"), 3000);
    // slideContainerEl.addEventListener("mouseenter", () => clearInterval(autoplay));

    // this.slideObserver = new IntersectionObserver((entries, observer) => {
    //     entries.forEach(entry => {
    //         if (entry.isIntersecting) {
    //             this.slider_item_index = entry.target.dataset.slideindex;

    //             this.querySelector('.slide-indicator.active').classList.remove('active');
    //             carouselEl.querySelectorAll('.slide-indicator')[slideIndex].classList.add('active');
    //         }
    //     });
    // }, { root: slideContainerEl, threshold: .1 });
    // document.querySelectorAll('.slide').forEach((slide) => {
    //     slideObserver.observe(slide);
    // });
  }

  getNewScrollPosition = (arg) => {
    const gap = +window
        .getComputedStyle(this.slider_container)
        .getPropertyValue("column-gap")
        .slice(0, 2),
      scroll_left = Math.round(this.slider_container.scrollLeft),
      slider_width = Math.round(this.slider_container.clientWidth),
      slider_scroll_width = Math.round(this.slider_container.scrollWidth),
      max_scroll_left = slider_scroll_width - slider_width;

    if (arg === "forward") {
      const x = scroll_left + slider_width;
      return x > max_scroll_left
        ? max_scroll_left - scroll_left < 5
          ? 0
          : max_scroll_left
        : x;
    } else if (arg === "backward") {
      const x = scroll_left - slider_width;
      return x < 0 ? (scroll_left == 0 ? max_scroll_left : 0) : x;
    } else if (typeof arg === "number") {
      const x = arg * (this.slider_item_width + gap);
      return x;
    }
  };
  navigate = (arg) => {
    this.slider_container.scrollLeft = this.getNewScrollPosition(arg);
  };
}
customElements.define("slider-components", SliderComponent);
